
import Vue from 'vue'
import FixingSVG from '../components/svg/fixing.vue'
import { useAppStore } from '@/store/app'

export default Vue.extend({
  name: 'Finished',
  components: {
    FixingSVG
  },
  setup () {
    const app = useAppStore()

    return {
      app
    }
  },
  data () {
    return {
      color: ''
    }
  },
  beforeMount () {
    this.color = this.app.primaryColor
  }
})
